import { Image, Row, Col } from "react-bootstrap";
import useWindowDimensions from "../../utils/useWindowDimensions";

// import Balloon from '../../assets/airballoon.png'
import ProposeImage from "../../assets/images/Proposal.png"

import styles from "./Proposing.module.css";

function Proposing() {
    const { height, width } = useWindowDimensions();
    return (
        <Row className={`${styles.ContentContainer} homePageVotingSection align-items-center`}>
            <Col className="d-flex">
                <div>
                    <div className={styles.votingTitle}>Proposal</div>
                    <div className={styles.votingSubtext}>You can start by filling the necessary details of your project and submitting your proposal in the standard format. Once the proposal goes through, the Voton community gets to view your proposal and share their opinion on it. The voters will contribute their votes to the projects they wish to support. The donation pool is forwarded to the proposer with the highest votes.<br/><br/>Your proposal gives you an opportunity to raise donations as well as gather valuable feedback for its development. You can choose to renew your proposal status after each voting period.</div>
                    {width < 992 ?
                        <Image src={ProposeImage} className={styles.votingBanner}></Image>
                        : <></>
                    }
                </div>
            </Col>
            {width < 992 ? <></> :
                <Col style={{ textAlign: 'end', position: 'relative' }}>
                    <Image src={ProposeImage} className={styles.votingBanner}></Image>
                </Col>
            }

        </Row>
    );
}

export default Proposing;